import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AclToolsService } from '../acl/tools/acl-tools.service';
import { AclResource } from '../acl/tools/decorators/acl-resource';

export const ACL_RESOURCES = {
  GET_STATISTICS_SUMMARIZE: 'statsShopManagement',
  PLACEMENTS: 'placementManagement',
  PLACEMENT_METRICS: 'statsPlacementMetricsManagement',
  GET_SHOPS: 'pubGetShop',
  MANAGE_SHOPS: 'pubManagement',
};

@Injectable({
  providedIn: 'root',
})
export class PublisherAclService {
  @AclResource(ACL_RESOURCES.PLACEMENTS)
  public canManagePlacements$: Observable<boolean>;

  @AclResource(ACL_RESOURCES.GET_STATISTICS_SUMMARIZE)
  public canSeeStatisticsSummarize$: Observable<boolean>;

  @AclResource(ACL_RESOURCES.GET_SHOPS)
  public canSeeShops$: Observable<boolean>;

  @AclResource(ACL_RESOURCES.MANAGE_SHOPS)
  public canManageShops$: Observable<boolean>;

  constructor(
    public aclTools: AclToolsService,
  ) {}
}
